import classNames from 'classnames';
import styles from './styles.module.scss';
import { FC, memo } from 'react';

export type TArrowButtonProps = {
  className?: string;
  onClick?: () => void;
};

const ArrowBackButton: FC<TArrowButtonProps> = memo(({ className, onClick }) => {
  const handleClick = () => {
    onClick?.();
    window.location.href = `${window.location.origin}/games`;
  };

  return (
    <button className={classNames(styles.arrowBack, 'simple-btn', className)} onClick={handleClick}>
      <span className={classNames(styles.icon, 'ui-icon-ArrowBack')}></span>
    </button>
  );
});

export default ArrowBackButton;
